<template>
    <div class="cmaj-menu">
        <div v-for="tabulation in tabulations"
             :id="tabulation.anchor"
             class="cmaj-menu-item"
            :class="{active: tabulation.active}"
             @click="scrollToTab(tabulation.anchor)"
            :style="'color:' + (tabulation.active ? primaryColor : 'gray') + '!important'"
             v-if="!tabulation.hidden">

            <div class="d-flex align-items-center gap-10 tab-title" >
                {{ getTabIndex(tabulation) }}. {{ tabulation.label }}

                <v-tooltip color="warning" bottom v-if="(tabulation.anchor === 'media-tab' && !hasMedia)">
                    <template v-slot:activator="{ on }">
                        <v-icon color="warning" v-on="on">warning</v-icon>
                    </template>
                    <div>Absence de photos</div>
                </v-tooltip>

                <v-tooltip color="warning" bottom
                    v-if="(tabulation.anchor === 'opening-period-tab' && !hasOpeningPeriods)">
                    <template v-slot:activator="{ on }">
                        <v-icon color="warning" v-on="on">warning</v-icon>
                    </template>
                    <div>Absence de périodes d'ouvertures</div>
                </v-tooltip>

                <v-tooltip color="warning" bottom v-if="(tabulation.anchor === 'price-period-tab' && !hasPricePeriods)">
                    <template v-slot:activator="{ on }">
                        <v-icon color="warning" v-on="on">warning</v-icon>
                    </template>
                    <div>Absence de tarifs</div>
                </v-tooltip>

                <v-icon :color="updateColors.deep" v-if="displayEditIcon(tabulation)">edit_note</v-icon>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "CmajFormMenu",
    props: ['tabulations', 'preview', "sit"],
    data() {
        return {
            loadingSave: false
        }
    },
    methods: {
        scrollToTab(anchor) {
            let element = document.getElementsByClassName(anchor)

            if (element !== undefined && element.length > 0) {
                element = element[0]

                element.scrollIntoView({
                    behavior: 'smooth'
                })
            }
        },
        save() {
            this.loadingSave = true
            this.$global.$emit('save-provider', true)
        },
        getTabIndex(tabulation) {
            let tabs = this.tabulations.filter(tabulation => !tabulation.hidden)

            return tabs.findIndex(tab => tab.code === tabulation.code) + 1
        },
        scroll() {
            let menu = document.getElementsByClassName("cmaj-menu")
            let cmajForm = document.getElementsByClassName("cmaj-form")
            let headerHeight = 164
            let paddingTop = 35
            let scrollHeight = document.documentElement.scrollTop

            if (menu !== undefined && menu.length > 0) {
                menu = menu[0]
                cmajForm = cmajForm[0]

                if (scrollHeight < headerHeight + paddingTop) {
                    menu.style.top = null
                    menu.classList.remove('fixed-menu')

                    if (cmajForm !== undefined) {
                        cmajForm.classList.remove('margin-menu')
                    }
                } else {
                    if(this.sit) {
                        menu.style.top = '80px'
                    } else {
                        menu.style.top = '15px'
                    }

                    menu.classList.add('fixed-menu')

                    if (cmajForm !== undefined) {
                        cmajForm.classList.add('margin-menu')
                    }
                }
            }
        },
        switchActiveTab() {
            let scrollHeight = document.documentElement.scrollTop

            this.tabulations.forEach(tab => {
                if (scrollHeight >= tab.offsetTop && scrollHeight < tab.offsetBot) {
                    this.tabulations.map(_tab => _tab.active = false)

                    tab.active = true
                }
            })
        },
        displayEditIcon(tab) {
             if(!this.readOnly) {
                 if(tab.anchor === 'general-tab' && this.generalTabDirty) {
                     return true
                 } else if(tab.anchor === 'localisation-tab' && this.localisationTabDirty) {
                     return true
                 } else if(tab.anchor === 'contact-tab' && this.communicationTabDirty) {
                     return true
                 } else if(tab.anchor === 'platform-tab' && this.platformTabDirty) {
                     return true
                 } else if(tab.anchor === 'specific-tab' && this.specificTabDirty) {
                     return true
                 } else if(tab.anchor === 'opening-period-tab' && this.openingTabDirty) {
                     return true
                 } else if(tab.anchor === 'price-period-tab' && this.pricesTabDirty) {
                     return true
                 } else if(tab.anchor === 'contacts-tab' && this.contactsTabDirty) {
                     return true
                 } else if(tab.anchor === 'media-tab' && this.mediasTabDirty) {
                     return true
                 }
             } else {
                 return false
             }
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'generalTabDirty', "localisationTabDirty", "communicationTabDirty",
            "platformTabDirty", "mediasTabDirty", "specificTabDirty", "openingTabDirty", "pricesTabDirty",
            "contactsTabDirty", 'readOnly', 'mediasTabDirty']),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
        ...mapState("sitAnswer", ['updateColors',]),
        hasMedia() {
            return this.provider.medias.length > 0
        },
        hasOpeningPeriods() {
            return this.provider.opening_periods.length > 0
        },
        hasPricePeriods() {
            return this.provider.price_periods.length > 0
        }
    },
    mounted() {
        document.addEventListener('wheel', this.scroll)
        document.addEventListener('scroll', this.scroll)

        document.addEventListener('wheel', this.switchActiveTab)
        document.addEventListener('scroll', this.switchActiveTab)
    },
    created() {
        this.$global.$on('scroll-tab', (anchor) => this.scrollToTab(anchor))
    },
    beforeDestroy() {
        document.removeEventListener('wheel', this.scroll)
        document.removeEventListener('scroll', this.scroll)

        document.removeEventListener('wheel', this.switchActiveTab)
        document.removeEventListener('scroll', this.switchActiveTab)

        this.$global.$off('scroll-tab')
    }
}
</script>